const FILE_EXTENSION_RE = /\.(csv|xlsx|xls|xlsm|txt|tsv|mbox|json|vcf)$/i;

export const canonicalizeTag = (raw = '') => {
  let value = String(raw || '').trim();
  if (!value) return '';
  value = value.replace(FILE_EXTENSION_RE, '');
  value = value.replace(/[-_]+/g, ' ');
  value = value.replace(/\s+/g, ' ').trim();
  return value;
};

export const formatTagLabel = (raw = '') => {
  const canonical = canonicalizeTag(raw);
  if (!canonical) return '';
  return canonical
    .split(' ')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const mergeCanonicalTags = (...lists) => {
  const byKey = new Map();
  lists.flat().forEach((tag) => {
    const label = formatTagLabel(tag);
    if (!label) return;
    const key = canonicalizeTag(label).toLowerCase();
    if (!byKey.has(key)) byKey.set(key, label);
  });
  return Array.from(byKey.values());
};

export const tagsEqual = (left = '', right = '') =>
  canonicalizeTag(left).toLowerCase() === canonicalizeTag(right).toLowerCase();

export const collapseTagCounts = (rows = []) => {
  const byKey = new Map();
  rows.forEach((row) => {
    const label = formatTagLabel(row?.tag);
    if (!label) return;
    const key = canonicalizeTag(label).toLowerCase();
    const count = Number(row.count) || 0;
    const existing = byKey.get(key);
    if (!existing || count > existing.count) {
      byKey.set(key, { tag: label, count });
    }
  });
  return Array.from(byKey.values());
};

export const datasetTagFromFilename = (filename = '') => formatTagLabel(filename);
